import { get } from 'lodash';
import { apiClientInstance } from './axiosClient';
import { metricsApi } from './metricsApi';
import apiMessageToProductMessage from './apiMessageToProductMessage';

const extractErrorMessage = err =>
    err.response
        ? get(err, 'response.data.message', 'Unknown error')
        : err.message;

const mapSweep = sweep => ({
    sweepId: sweep.sweepId,
    name: sweep.name,
    description: sweep.description,
    prize: sweep.prize,
    status: sweep.status,
    sportType: sweep.sportType,
    displayOrder: sweep.displayOrder,
    openDate: sweep.openDate,
    closeDate: sweep.closeDate,
    allocationDate: sweep.allocationDate,
    roundId: sweep.roundId,
    consumerId: sweep.consumerId,
    copyFestivalName: sweep.copyFestivalName,
    copyEnabled: sweep.copyEnabled,
    copyDescription: sweep.copyDescription,
    copyHeader: sweep.copyHeader,
    copyText: sweep.copyText,
    winnerName: sweep.winnerName || null,
    winnerLocation: sweep.winnerLocation || null,
    assets: {
        heroBannerUrl: get(sweep, 'assets.heroBanner.url', null),
        backgroundUrl: get(sweep, 'assets.background.url', null),
        prizeUrl: get(sweep, 'assets.prize.url', null)
    },
    event: {
        name: get(sweep, 'event.name', null),
        startDate: get(sweep, 'event.startDate', null),
        status: get(sweep, 'event.status', null),
        metadata: get(sweep, 'event.metadata', null),
        winningSelections: get(sweep, 'event.winningSelections', [])
    },
    dataTTLExpiry: sweep.dataTTLExpiry
});

export const getSweepsByConsumerId = async ({ consumerId }) => {
    try {
        const { data } = await apiClientInstance.get('/client/sweepstake', {
            params: { consumerId }
        });

        const sweeps = (data.sweeps || []).map(mapSweep);

        return {
            data: sweeps,
            errorMessage: null
        };
    } catch (err) {
        const errorMessage = extractErrorMessage(err);
        const statusCode = get(err, 'response.status', 500);
        await metricsApi.errorMetric(
            'getSweepsByConsumerId',
            statusCode,
            errorMessage
        );

        return {
            data: [],
            errorMessage: apiMessageToProductMessage(errorMessage)
        };
    }
};

export const getEntryBySweepId = async ({ sweepId, productToken }) => {
    try {
        const { data } = await apiClientInstance.get(
            `/client/sweepstake/${sweepId}/entry`,
            {
                headers: {
                    Authorization: `Bearer ${productToken}`
                }
            }
        );

        return {
            data: {
                selection: {
                    id: data.selection.id,
                    name: data.selection.name,
                    metaData: data.selection.metaData
                },
                hasEntered: true
            },
            errorMessage: null
        };
    } catch (err) {
        const statusCode = get(err, 'response.status', 500);

        if (statusCode === 404) {
            return {
                data: {
                    selection: {
                        id: null,
                        name: null,
                        metaData: {}
                    },
                    hasEntered: false
                },
                errorMessage: null
            };
        }

        const errorMessage = extractErrorMessage(err);

        await metricsApi.errorMetric(
            'getEntryBySweepId',
            statusCode,
            errorMessage
        );

        return {
            data: {
                selection: {
                    id: null,
                    name: null,
                    metaData: {}
                },
                hasEntered: false
            },
            errorMessage: apiMessageToProductMessage(errorMessage)
        };
    }
};
